import React from 'react';

const EscMonthlyReportFilter = ({ project, handleFilter, setProject, setYear, years, setMonth }) => {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June', 'July',
    'August', 'September', 'October', 'November', 'December'
  ];

  return (
    <div className="flex items-center">
      <div className="pb-1 pl-10">
        <select
          defaultValue={'year'}
          onChange={(e) => setYear(e.target.value)}
          id="underline_select"
          className="block w-20 py-2.5 px-0 w-16 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 peer"
        >
          <option value="year">Year</option>
          {years.map((year, i) => (
            <option key={i} value={year}>{year}</option>
          ))}
        </select>
      </div>
      <div className="pb-1 pl-10">
        <select
          defaultValue={'month'}
          onChange={(e) => setMonth(e.target.value)}
          id="underline_select"
          className="block w-40 py-2.5 px-0 w-40 text-sm text-gray-500 bg-transparent border-0 border-b-2 border-gray-200 appearance-none focus:outline-none focus:ring-0 focus:border-gray-200 peer"
        >
          <option value="month">Month</option>
          {months.map((month, i) => (
            <option key={i} value={i + 1}>{month}</option>
          ))}
        </select>
      </div>
      <div className="pb-1 pl-10 mt-2">
        <button
          onClick={handleFilter}
          type="button"
          className="w-20 flex justify-center text-white bg-mgray hover:bg-myellowdark hover:text-black focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm py-1 text-center"
        >
          Fetch
        </button>
      </div>
    </div>
  );
};

export default EscMonthlyReportFilter;
